// extracted by mini-css-extract-plugin
export default {"dialog":"CetsDialog_dialog__owkkS","buttons":"CetsDialog_buttons__-FHP0","button_wrapper":"CetsDialog_button_wrapper__iFU03","message":"CetsDialog_message__ZNcN8"};